import * as React from "react";
import {FocusEvent, forwardRef, useState} from "react";
import CpfCnpjProps from './CpfCnpjProps';
import {InputText} from "primereact/inputtext";
import CpfCnpjUtils from "../../utils/CpfCnpjUtils";

const CpfCnpj = forwardRef((props: CpfCnpjProps, inputRef?: any) => {
    const [cpfCnpjInvalido, setCpfCnpjInvalido] = useState<boolean>(false);

    const mascaraDocumentosOnBlurHandler = (e: FocusEvent<HTMLInputElement, Element>) => {
        CpfCnpjUtils.formatarCampo(e.target);

        // @ts-ignore
        if (!CpfCnpjUtils.isCpfCnpj(e.target.value)) {
            setCpfCnpjInvalido(true);
        } else {
            setCpfCnpjInvalido(false);
        }

        if (props.onBlurHandler) {
            props.onBlurHandler(e);
        }
    }

    const mascaraDocumentosOnFocusHandler = (e: FocusEvent<HTMLInputElement, Element>) => {
        CpfCnpjUtils.retirarFormatacao(e.target);

        if (props.onFocusHandler) {
            props.onFocusHandler(e);
        }
    }

    return (
        <>
            <InputText id={props.id} value={props.value}
                   ref={inputRef}
                   keyfilter={"pint"}
                   tooltip={props.tooltip}
                   invalid={props.invalid ? props.invalid : cpfCnpjInvalido}
                   placeholder={props.placeholder}
                   required={props.required}
                   maxLength={props.maxLength}
                   style={props.style}
                   onBlur={mascaraDocumentosOnBlurHandler}
                   onFocus={mascaraDocumentosOnFocusHandler}
                   onChange={props.onChangeHandler}/>
        </>
    );
});

export default CpfCnpj;